/**
 * Mapeia rotas do app para códigos de módulo do subscription-service (alinhado a KNOW_MODULES).
 * Se o path não tiver regra, considera exigir apenas `base` ou `dashboard`.
 */
export function moduleCodeForPath(path) {
  const p = path || '/';
  if (p.startsWith('/super-admin')) return 'base';
  if (p === '/') return 'base';
  if (p.startsWith('/me')) return 'base';
  if (p.startsWith('/assistant')) return 'base';
  if (p.startsWith('/map') || p.startsWith('/notifications')) return 'monitoring';
  if (p.startsWith('/reports')) return 'dashboard';
  if (p.startsWith('/license') || p.startsWith('/licenses') || p.startsWith('/legislation') || p.startsWith('/files')) return 'license';
  if (p.startsWith('/portal')) return 'license';
  if (p.startsWith('/inspections')) return 'complaint';
  if (p.startsWith('/process')) return 'process';
  if (p.startsWith('/complaint')) return 'complaint';
  if (p.startsWith('/institution')) return 'institution';
  if (p.startsWith('/identity') || p.startsWith('/enterprises')) return 'identity';
  if (p.startsWith('/catalog')) return 'catalog';
  if (p.startsWith('/professional')) return 'professional';
  if (p.startsWith('/contact')) return 'identity';
  if (p.startsWith('/users') || p.startsWith('/profile') || p.startsWith('/settings') || p.startsWith('/history') || p.startsWith('/trash')) return 'base';
  return 'base';
}

/**
 * @param {Set<string>|null|undefined} moduleSet — null = sem filtro (ex.: serviço indisponível)
 * @param {string} path
 */
export function isPathAllowedBySubscription(path, moduleSet) {
  if (moduleSet == null) return true;
  const need = moduleCodeForPath(path);
  if (moduleSet.has(need)) return true;
  if (need === 'dashboard' && moduleSet.has('base')) return true;
  return false;
}

export function filterNavBySubscription(items, moduleSet) {
  if (moduleSet == null) return items;
  return items.filter((item) => isPathAllowedBySubscription(item.path, moduleSet));
}
